export type PathType = {
    top: string;
    booking: string;
    signin: string;
    systemBusy: string;
    confirm: string;
};

const TOP_PATH = `/`;
const BOOKING_PATH = `/solvent`;
const ERROR_PATH = `${TOP_PATH}error`;
const CONFIRM_PATH = `${TOP_PATH}confirm`;

export const Paths: PathType = {
    top: `${TOP_PATH}`,
    booking: `${BOOKING_PATH}`,
    signin: `${TOP_PATH}signin`,
    systemBusy: `${ERROR_PATH}/system-busy`,
    confirm: `${CONFIRM_PATH}`,
};
